// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__12Po7","buttons":"PendingPaymentAlert_buttons__29_pp"};